<div>

    <div>

        <ul class=" pagination   flex justify-content-center">
            <!-- frist Page Button -->
            @if(currentPage > 1){
            <li (click)="goToPage(1)">
                First
            </li>
            }
            <!-- Previous Button -->
            @if(currentPage > 1){
            <li (click)="goToPage(currentPage - 1)">
                <a>&laquo;</a>
            </li>
            }
            <!-- Page Numbers -->
            @for (page of getPagesRange(); track $index) {
            <li [class.active]="page === currentPage" (click)="goToPage(page)">
                <a>{{ page }}</a>
            </li>
            }
            <!-- Next Button -->
            <li *ngIf="currentPage < totalPages" (click)="goToPage(currentPage + 1)">

                <a>&raquo;</a>
            </li>
            <!-- First Page Button -->
            @if(currentPage < totalPages){ <li class="page-item" (click)="goToPage(totalPages)">

                Last
                </li>
                }
        </ul>

    </div>
    <div class="flex align-items-center justify-content-center gap-5 w-12">
        <select [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
        </select>
        <div class="pagination-summary flex gap-5">
            <span>
                showing {{ currentPage }} - {{ totalPages }}
            </span>
            <span>
                {{totalItems}} items
            </span>

        </div>

    </div>

</div>